import own from "./own.js";
import company from "./company.js";

export default [
    {
        path: "/myApp/:companyId",
        name: "myApp",
        meta: {
            title: "我的应用",
            isMenu: true,
            isRight: true,
            custom: true,
            icon: "bri-home-outline",
            iconSelect: "bri-home"
        },
        props: true,
        component: () => import("@/views/myApp/myApp.vue")
    },
    {
        path: "/companyAdd",
        name: "companyAdd",
        meta: {
            title: "添加公司",
            isMenu: true,
            isRight: true,
            noneCompanyId: true,
            custom: true,
            icon: "bri-home-outline",
            iconSelect: "bri-home"
        },
        component: () => import("@/views/company/companyAdd.vue")
    },
    {
        path: "/myPackge/:companyId",
        name: "myPackge",
        meta: {
            title: "我的数据包",
            isMenu: true
        },
        props: true,
        component: () => import("@/views/dataCenter/export/myPackge.vue")
    },
    {
        path: "/appStore/:companyId",
        name: "appStore",
        meta: {
            title: "应用中心",
            isMenu: true
        },
        props: true,
        component: () => import("@/views/appStore/appStore.vue")
    },
    {
        path: "/dataCenter/:companyId",
        name: "dataCenter",
        meta: {
            title: "数据中心",
            isMenu: true
        },
        props: true,
        component: () => import("@/views/dataCenter/dataCenter.vue")
    },
    {
        path: "/addressBook/:companyId",
        name: "addressBook",
        meta: {
            title: "通讯录",
            isRight: true,
            icon: "bri-addressBook-outline",
            iconSelect: "bri-addressBook",
            custom: true
        },
        props: true,
        component: () => import("@/views/company/export/addressBook.vue")
    },
    {
        path: "/help",
        name: "help",
        meta: {
            title: "帮助中心",
            isRight: true,
            icon: "bri-help-outline",
            iconSelect: "bri-help",
            custom: true
        }
    },
    own,
    company
];



// WEBPACK FOOTER //
// ./src/router/modules/home.js